import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'gatehouse',
      d: 'M-3.5,-6.5h0.5v0.5h-0.5zM2.5,-6.5h0.5v0.5h-0.5zM-3.5,-6h2.5v0.5h-2.5zM1.5,-6h0.5v0.5h-0.5zM-3.5,-5.5h4v1h-4zM-3.5,-4.5h0.5v1.5h-0.5zM-2,-4.5h2.5v0.5h-2.5zM-2,-4h1.5v1h-1.5zM-3.5,-3h1v0.5h-1zM-2,-3h1v0.5h-1zM-3.5,-2.5h2.5v1.5h-2.5zM3,-2h0.5v0.5h-0.5zM2,-1.5h1.5v0.5h-1.5zM-3.5,-1h1v0.5h-1zM-2,-1h1v0.5h-1zM1.5,-1h0.5v0.5h-0.5zM-3.5,-0.5h2.5v0.5h-2.5zM3,-0.5h0.5v0.5h-0.5zM-3,0h2v0.5h-2zM2,0h0.5v0.5h-0.5zM-1.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['gatehouse', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M3,-6.5h0.5v0.5h-0.5zM2,-6h1.5v0.5h-1.5zM0.5,-5.5h3v1h-3zM-3,-4.5h1v0.5h-1zM0.5,-4.5h1.5v0.5h-1.5zM2.5,-4.5h1v1h-1zM-3,-4h0.5v1h-0.5zM1,-4h1v0.5h-1zM1,-3.5h2.5v0.5h-2.5zM-2.5,-3h0.5v0.5h-0.5zM1.5,-3h2v1h-2zM1.5,-2h1.5v0.5h-1.5zM1.5,-1.5h0.5v0.5h-0.5zM2,-1h1.5v0.5h-1.5zM1.5,-0.5h1.5v0.5h-1.5zM1.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['gatehouse', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3.5,-7.5h1.5v1h-1.5zM2.5,-7.5h1v1h-1zM-1.5,-7h1v0.5h-1zM1,-7h1v0.5h-1zM-3,-6.5h3v0.5h-3zM1,-6.5h1.5v0.5h-1.5zM-1,-6h2.5v0.5h-2.5zM-2.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'chimney',
      d: 'M-0.5,-4h1.5v0.5h-1.5zM-0.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h0.5v0.5h-0.5zM-1,-3h0.5v4h-0.5zM1,-3h0.5v1h-0.5zM0.5,-2h1v3h-1z',
    },
    { paint: 'trunk', d: 'M0,-3.5h0.5v0.5h-0.5zM-0.5,-3h1.5v1h-1.5zM-0.5,-2h1v0.5h-1z' },
    { paint: 'shadow', d: 'M2,-4.5h0.5v1h-0.5zM-2.5,-4h0.5v1h-0.5z' },
  ],
  pixels: 201,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
